import { render, staticRenderFns } from "./AccessFormTemplate.vue?vue&type=template&id=45740a08"
import script from "./AccessFormTemplate.vue?vue&type=script&lang=js"
export * from "./AccessFormTemplate.vue?vue&type=script&lang=js"
import style0 from "./AccessFormTemplate.vue?vue&type=style&index=0&id=45740a08&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports